import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { initializeMetaPixel, trackInitiateCheckout } from './utils/metaPixel';
import { Moon, Star, ArrowDown, Check, X, ArrowRight, ShieldCheck, Plus, Minus, Gift, BookOpen, Baby, Heart, Clock, CheckCircle2 } from 'lucide-react';
export function App() {
  useEffect(() => {
    initializeMetaPixel();
  }, []);
  return <div className="font-dmsans text-gray-800 bg-cream min-h-screen scroll-smooth" data-id="element-0" data-mp="2rlf7iw6ufu4f">
      <HeroSection data-id="element-1" data-mp="2mmvnx2fq2uf8" />
      <WhoIsItForSection data-id="element-2" data-mp="2mnnhk7prei2v" />
      <BridgeSection data-id="element-3" data-mp="2mjzplczyq3q9" />
      <CreatorSection data-id="element-4" data-mp="31b8ka0iq2fa9" />
      <BeforeAfterSection data-id="element-5" data-mp="31brzvakwgrl4" />
      <WhatYouReceiveSection data-id="element-6" data-mp="31c1igd3m7wgs" />
      <BonusesSection data-id="element-7" data-mp="2wk06ksad07ra" />
      <TestimonialsSection data-id="element-8" data-mp="2wjqgz5t882m4" />
      <FAQSection data-id="element-9" data-mp="2wiffxdr618yp" />
      <OffersSection data-id="element-10" data-mp="2whxb3sqftmf6" />
      <ValueSummarySection data-id="element-11" data-mp="28ufmg62gz4gf" />
      <GuaranteeSection data-id="element-12" data-mp="28tmi1bqzgr1g" />
      <FinalCTASection data-id="element-13" data-mp="28suvsrja05nu" />
    </div>;
}
function HeroSection() {
  return <section className="bg-salvia-dark text-white py-20 px-6 relative overflow-hidden flex flex-col items-center text-center" data-id="element-14" data-mp="23u9u0nodldxa">
      <div className="absolute top-0 left-0 w-full h-full opacity-10 pointer-events-none" data-id="element-15" data-mp="3ijpbavgxap74">
        {/* Decorative organic branches could go here as SVG background */}
      </div>

      <div className="max-w-4xl mx-auto z-10 flex flex-col items-center" data-id="element-16" data-mp="3rdkisa5iorpx">
        <Moon className="w-16 h-16 text-rose mb-6" data-id="element-17" data-mp="6htxpd5ixiv" />

        <h1 className="font-playfair text-4xl md:text-5xl lg:text-[52px] leading-tight mb-8" data-id="element-18" data-mp="82kl3wchwbg">
          El método para que tu bebé duerma toda la noche, sin dejarlo llorar.
        </h1>

        <p className="text-rose text-lg md:text-[20px] max-w-2xl mx-auto mb-6" data-id="element-19" data-mp="33mymfg4vkvvr">
          Creado con amor para que tu maternidad sea más liviana y dejes de
          levantarte en cada madrugada.
        </p>

        <div className="mb-8" data-id="element-20" data-mp="3diruonbka37q">
          <span className="font-playfair text-2xl font-bold tracking-wider text-rose" data-id="element-21" data-mp="nvsub5qlapwh">
            Mamá sin Caos
          </span>
        </div>

        <a href="#ofertas" className="inline-block bg-rose hover:bg-rose-600 text-white font-bold py-4 px-10 rounded-xl transition-colors duration-300 text-lg shadow-lg mb-12" data-id="element-22" data-mp="stccggqermtp">
          ✨ QUIERO QUE MI BEBÉ DUERMA ✨
        </a>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        ease: 'easeOut'
      }} className="w-full max-w-4xl mx-auto" data-id="element-23" data-mp="d4e9i476jx1z">
          <img src="https://cdn.magicpatterns.com/uploads/mKhs5wjS8BXpHQnivgjMRR/Para_la_pagina_de_venta.png" alt="El Manual del sueño infantil — Mamá sin Caos, con 3 bonos exclusivos" className="w-full h-auto rounded-2xl shadow-2xl" data-id="element-24" data-mp="3bncnzq614q00" />
        </motion.div>
      </div>
    </section>;
}
function TestimonialsSection() {
  const testimonials = [{
    text: 'Mi bebé de 5 meses empezó a dormir 5 horas seguidas en la primera semana. Lloré de alivio cuando me di cuenta de que era posible.',
    name: 'Valentina M.',
    detail: 'Mamá de Luca (5 meses) Buenos Aires',
    avatar: 'https://i.pravatar.cc/150?img=1'
  }, {
    text: 'Tenía miedo de que fuera otro método de dejar llorar. No tiene nada que ver. Es suave, tiene sentido y funciona. Mi hija pasó de despertarse 6 veces a dormir casi toda la noche.',
    name: 'Camila R.',
    detail: 'Mamá de Sofía (7 meses) Córdoba',
    avatar: 'https://i.pravatar.cc/150?img=5'
  }, {
    text: 'Lo leí de madrugada mientras la amamantaba. Al tercer día ya noté la diferencia en las siestas. Al séptimo día dormí 6 horas seguidas por primera vez en meses.',
    name: 'Florencia T.',
    detail: 'Mamá de Mateo (4 meses) Rosario',
    avatar: 'https://i.pravatar.cc/150?img=9'
  }, {
    text: "No lo podía creer. Pensaba que mi bebé era 'de los que no duermen'. Resulta que era yo la que no sabía cómo enseñarle. Ahora sí sé.",
    name: 'Luciana P.',
    detail: 'Mamá de Emma (9 meses) Mendoza',
    avatar: 'https://i.pravatar.cc/150?img=10'
  }];
  return <section className="bg-cream py-20 px-6" data-id="element-25" data-mp="m4uir27bjel3">
      <div className="max-w-6xl mx-auto" data-id="element-26" data-mp="h72po4uxtmfb">
        <h2 className="font-playfair text-3xl md:text-4xl text-salvia-dark text-center mb-12 max-w-3xl mx-auto" data-id="element-27" data-mp="h8432fzfel07">
          Mirá lo que cambió en la vida de más de 1.000 mamás después de aplicar
          el Manual de Sueño Infantil:
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-28" data-mp="14wx0kgvp50wx">
          {testimonials.map((t, i) => <div key={i} className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 flex flex-col h-full" data-id="element-29" data-mp="zxk372778bg3" data-mpi={i}>
              <div className="flex text-gold mb-4" data-id="element-30" data-mp="vvyvrwdfopda">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-5 h-5 fill-current" data-id="element-31" data-mp="3kpdw2pzimcms" data-mpi={j} />)}
              </div>
              <p className="text-gray-700 italic mb-6 flex-grow text-lg" data-id="element-32" data-mp="3gok7rvi5uvtd">
                "{t.text}"
              </p>
              <div className="flex items-center mt-auto" data-id="element-33" data-mp="2060abs7c4vpc">
                <img src={t.avatar} alt={t.name} className="w-12 h-12 rounded-full mr-4 object-cover" data-id="element-34" data-mp="206jtfc8q1q4y" />
                <div data-id="element-35" data-mp="29w3b4ekp7dy8">
                  <p className="font-bold text-salvia" data-id="element-36" data-mp="29xegujxpevrz">{t.name}</p>
                  <p className="text-sm text-gray-500" data-id="element-37" data-mp="2evg29bilr76m">{t.detail}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}
function BridgeSection() {
  return <section className="bg-rose-verysoft py-16 px-6 flex flex-col items-center text-center relative" data-id="element-38" data-mp="2nwntxaqm59rq">
      <div className="w-24 h-px bg-rose mb-8" data-id="element-39" data-mp="2stecq5tsyjgu"></div>
      <h2 className="font-playfair italic text-2xl md:text-3xl text-salvia-dark max-w-3xl mx-auto leading-relaxed" data-id="element-40" data-mp="thld01fmr00f">
        Seguí leyendo y entendé por qué el Manual de Sueño Infantil es el más
        completo y gentil del mercado.
      </h2>
      <div className="w-24 h-px bg-rose mt-8 mb-8" data-id="element-41" data-mp="21sdee1xe9ng6"></div>

      <motion.div animate={{
      y: [0, 10, 0]
    }} transition={{
      repeat: Infinity,
      duration: 2
    }} data-id="element-42" data-mp="1wshd4ag30a4b">
        <ArrowDown className="w-8 h-8 text-salvia" data-id="element-43" data-mp="2atjz6n72tkf8" />
      </motion.div>
    </section>;
}
function CreatorSection() {
  return <section className="bg-cream py-20 px-6" data-id="element-44" data-mp="2kqg8uw8pocld">
      <div className="max-w-4xl mx-auto flex flex-col md:flex-row items-center gap-12" data-id="element-45" data-mp="2kp54ovbct2tq">
        <div className="md:w-1/3 flex flex-col items-center" data-id="element-46" data-mp="2fqaev9eyye04">
          <div className="w-48 h-48 rounded-full p-2 border-4 border-rose mb-6" data-id="element-47" data-mp="2tiqhwa7vec11">
            <img src="https://cdn.magicpatterns.com/uploads/aSrEGBYEhjYBegAu5hQKA6/ChatGPT_Image_30_jun_2026,_11_18_39_p.m..png" alt="Luciana Vazcoba" className="w-full h-full rounded-full object-cover object-[75%_20%]" data-id="element-48" data-mp="2tkkvf3gtb1v3" />
          </div>
          <div className="text-center" data-id="element-49" data-mp="2yfqg5yyhaahl">
            <p className="font-playfair text-2xl text-salvia font-bold mb-2" data-id="element-50" data-mp="3i33g1d2umguv">
              Luciana Vazcoba
            </p>
            <a href="https://www.instagram.com/mamasiincaos/" target="_blank" rel="noopener noreferrer" className="block text-sm text-gray-600 mb-1 hover:text-salvia transition-colors" data-id="element-51" data-mp="3n1enxi9l2hag">
              📱 @mamasiincaos
            </a>
            <a href="https://www.mamasincaos.store/" target="_blank" rel="noopener noreferrer" className="block text-sm text-gray-600 hover:text-salvia transition-colors" data-id="element-52" data-mp="2zcdathpt2hyu">
              🌐 mamasincaos.store
            </a>
          </div>
        </div>

        <div className="md:w-2/3 space-y-6 text-lg text-gray-700" data-id="element-53" data-mp="2uebqyukk2emb">
          <p data-id="element-54" data-mp="2gfc51uofgdtu">
            <span className="text-salvia font-bold" data-id="element-55" data-mp="2geswv5okx3t0">
              🌿 Mi nombre es Luciana Vazcoba.
            </span>{' '}
            Soy periodista y, por eso, durante mi proceso de maternidad como
            primeriza me dediqué a investigar y a escribir todo lo que me sirvió
            para que el sueño infantil de mi bebé no fuese un problema. Así
            nació: El Manual del sueño infantil.
          </p>
          <p data-id="element-56" data-mp="2qzaj370bl6j8">
            A través del método que desarrollé, soy responsable de transformar
            la vida de más de 1.000 familias argentinas que aplican mi
            metodología y logran que sus bebés duerman hasta 10 horas seguidas.
          </p>
          <p data-id="element-57" data-mp="2d4ro3gmph5ay">
            El método que diseñé en este Manual te permite enseñarle a tu bebé
            con amor y respeto, para que no sufra ningún tipo de trauma en el
            proceso. Porque creemos que un bebé puede aprender a dormir sin
            necesidad de ser abandonado a su llanto.
          </p>
          <div className="bg-white p-6 rounded-xl border-l-4 border-rose mt-8 italic text-salvia-dark font-playfair text-xl" data-id="element-58" data-mp="1y78r5qzvjlsf">
            "Mamá sin Caos nació de una madrugada de agotamiento. Y hoy ayuda a
            miles de familias a recuperar el descanso que merecen."
          </div>
        </div>
      </div>
    </section>;
}
function WhatYouReceiveSection() {
  const items = ['Los fundamentos del sueño infantil y las tablas de ventanas de sueño por edad (0 a 12 meses), con horarios adaptados a la realidad argentina.', 'Cómo construir siestas y sueño nocturno paso a paso, y soltar las asociaciones (teta, brazos, hamaca) de forma gradual y respetuosa.', 'El Protocolo de Transferencia Invisible para pasar al bebé de los brazos a la cuna sin que se despierte, y cómo resolver despertares y regresiones.', 'El ambiente ideal para dormir: temperatura, oscuridad y ruido blanco explicados con datos… y mucho más.'];
  return <section className="bg-offwhite py-20 px-6 relative" data-id="element-59" data-mp="33g35jwtsfbyn">
      <div className="max-w-4xl mx-auto" data-id="element-60" data-mp="33fjo0h81upl5">
        <div className="flex items-center justify-between mb-12" data-id="element-61" data-mp="38emum63oh3v8">
          <h2 className="font-playfair text-3xl md:text-4xl text-rose font-bold flex items-center" data-id="element-62" data-mp="38ctjoem17xhf">
            <BookOpen className="mr-4 w-8 h-8" data-id="element-63" data-mp="2f97vd81ebcd2" />
            LO QUE RECIBÍS EN EL MANUAL DE SUEÑO INFANTIL
          </h2>
          <Moon className="w-12 h-12 text-salvia opacity-20 hidden md:block" data-id="element-64" data-mp="2p5b632abcjbm" />
        </div>

        <p className="text-xl text-gray-700 mb-10" data-id="element-65" data-mp="2u4e2jyc89h7z">
          El Manual consiste en un eBook completo con información valiosa para
          atender desde recién nacidos hasta bebés de 12 meses.
        </p>

        <div className="space-y-4" data-id="element-66" data-mp="21fgxwy0xvixp">
          <p className="font-bold text-salvia-dark text-xl mb-6" data-id="element-67" data-mp="21grxelncq4j0">
            Vas a aprender:
          </p>
          {items.map((item, i) => <div key={i} className="bg-white p-5 rounded-lg shadow-sm border-l-[3px] border-rose flex items-start" data-id="element-68" data-mp="26cyvxtdf4dqx" data-mpi={i}>
              <Check className="w-6 h-6 text-salvia mr-4 flex-shrink-0 mt-0.5" data-id="element-69" data-mp="1dpcvgtzhlp8a" />
              <p className="text-gray-700 text-lg" data-id="element-70" data-mp="1iofo1eya62zd">{item}</p>
            </div>)}
        </div>
      </div>
    </section>;
}
function BeforeAfterSection() {
  const before = ['Te levantás de madrugada múltiples veces por los despertares nocturnos', 'Tu bebé solo duerme si está en brazos o tomando la teta', 'Te sentís agotada porque no podés dormir seguido', 'La maternidad se vuelve pesada y la familia vive cansada y estresada', 'Las siestas son cortas y con mucha resistencia cada vez', 'Sentís que probaste todo y nada funciona'];
  const after = ['Tu bebé va a aprender a dormir con autonomía y sin tu presencia', 'Las siestas van a ser buenas, largas y sin resistencia', 'Vas a dormir toda la noche porque tu bebé no va a despertarse en la madrugada', 'Tu familia va a ser más unida, más tranquila y más feliz', 'La maternidad se vuelve liviana y recuperás tiempo para cuidarte a vos misma', 'Vas a disfrutar a tu bebé en lugar de solo sobrevivir el día a día'];
  return <section className="bg-cream py-20 px-6" data-id="element-71" data-mp="2pd53temupnh3">
      <div className="max-w-6xl mx-auto" data-id="element-72" data-mp="2fn6l62c8a9x6">
        <div className="flex flex-col lg:flex-row gap-8 items-stretch" data-id="element-73" data-mp="2fm4yf0lunyzm">
          {/* Before */}
          <div className="flex-1 bg-red-50 rounded-2xl p-8 border border-red-100" data-id="element-74" data-mp="2knuc6o0giqre">
            <h3 className="font-playfair text-2xl text-gray-800 font-bold mb-8 flex items-center" data-id="element-75" data-mp="26o2y6n9xxade">
              <span className="text-2xl mr-3" data-id="element-76" data-mp="2aovbpspui1fh">⚡</span> LO QUE PASA SI NO
              APLICÁS EL MANUAL:
            </h3>
            <div className="space-y-6" data-id="element-77" data-mp="2yg0q03g50lno">
              {before.map((item, i) => <div key={i} className="flex items-start" data-id="element-78" data-mp="33citz13n8fyy" data-mpi={i}>
                  <X className="w-6 h-6 text-red-400 mr-4 flex-shrink-0 mt-0.5" data-id="element-79" data-mp="2pm5hclft4d3a" />
                  <p className="text-gray-700" data-id="element-80" data-mp="2tmz8rosgka0x">{item}</p>
                </div>)}
            </div>
          </div>

          {/* Arrow */}
          <div className="hidden lg:flex items-center justify-center" data-id="element-81" data-mp="3hb8qaein2bm9">
            <div className="bg-white p-4 rounded-full shadow-md" data-id="element-82" data-mp="3m3rzz0e7gmls">
              <ArrowRight className="w-8 h-8 text-salvia" data-id="element-83" data-mp="1aojewijyemrf" />
            </div>
          </div>

          {/* After */}
          <div className="flex-1 bg-salvia-soft rounded-2xl p-8 border border-salvia-light" data-id="element-84" data-mp="15pzs6fxjd6y0">
            <h3 className="font-playfair text-2xl text-salvia font-bold mb-8 flex items-center" data-id="element-85" data-mp="1ke2zptr88qox">
              <Moon className="w-6 h-6 mr-3 text-salvia" data-id="element-86" data-mp="1ffjexwoddky5" /> LO QUE VA A PASAR
              DESPUÉS DE APLICAR EL MANUAL:
            </h3>
            <div className="space-y-6" data-id="element-87" data-mp="rqgmruw409pe">
              {after.map((item, i) => <div key={i} className="flex items-start" data-id="element-88" data-mp="mrdnys6q2zpv" data-mpi={i}>
                  <CheckCircle2 className="w-6 h-6 text-salvia mr-4 flex-shrink-0 mt-0.5" data-id="element-89" data-mp="msyiiht1einq" />
                  <p className="text-gray-800 font-medium" data-id="element-90" data-mp="11liaqnenf5qe">{item}</p>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}
function WhoIsItForSection() {
  const avatars = [{
    icon: <Baby className="w-12 h-12 text-rose-DEFAULT" data-id="element-91" data-mp="284qcotg026ic" />,
    title: 'MAMÁS EMBARAZADAS',
    desc: 'Que quieren aprender con anticipación todo sobre el sueño infantil antes de que nazca el bebé, evitando el estrés y el cansancio de los primeros meses.',
    bg: 'bg-rose-soft'
  }, {
    icon: <Clock className="w-12 h-12 text-salvia-dark" data-id="element-92" data-mp="qmghq3yf2i6t" />,
    title: 'MAMÁS DE BEBÉS DE 0 A 6 MESES',
    desc: 'Que quieren establecer buenos hábitos de sueño desde los primeros meses de vida. Al aplicar las técnicas del manual, tu bebé va a crecer durmiendo en el momento justo.',
    bg: 'bg-cream'
  }, {
    icon: <Moon className="w-12 h-12 text-salvia" data-id="element-93" data-mp="15j7jukzh6804" />,
    title: 'MAMÁS DE BEBÉS DE 6 A 12 MESES',
    desc: 'Si tu bebé ya tiene más de 6 meses y todavía no duerme solo, el manual te va a mostrar exactamente qué hacer para terminar con los despertares nocturnos de una vez por todas.',
    bg: 'bg-salvia-light'
  }, {
    icon: <Heart className="w-12 h-12 text-gold" data-id="element-94" data-mp="1ob9spa5vkjzt" />,
    title: 'PAPÁS Y FAMILIAS QUE QUIEREN ACOMPAÑAR CON AMOR',
    desc: 'En este método no vas a encontrar abandono ni llanto sin respuesta. Al contrario: vas a enseñar autonomía con amor, respeto y presencia constante.',
    bg: 'bg-gold-soft'
  }];
  return <section className="bg-white py-20 px-6" data-id="element-95" data-mp="1oghezbseiohs">
      <div className="max-w-6xl mx-auto" data-id="element-96" data-mp="1ohar6sa4q67b">
        <h2 className="font-playfair text-3xl md:text-4xl text-salvia font-bold text-center mb-16" data-id="element-97" data-mp="1kfp7amz6grnm">
          ¿PARA QUIÉN ES ESTE MANUAL?
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-98" data-mp="2h56hnf93v1vn">
          {avatars.map((avatar, i) => <div key={i} className={`${avatar.bg} p-8 rounded-2xl flex flex-col items-center text-center shadow-sm`} data-id="element-99" data-mp="2c7ddssv9yjyj" data-mpi={i}>
              <div className="bg-white p-4 rounded-full shadow-sm mb-6" data-id="element-100" data-mp="23f33lbkdqeha">
                {avatar.icon}
              </div>
              <h3 className="font-bold text-xl text-gray-800 mb-4" data-id="element-101" data-mp="2zxqy1x7mbeik">
                {avatar.title}
              </h3>
              <p className="text-gray-700" data-id="element-102" data-mp="2v3cyrjpu4n8m">{avatar.desc}</p>
            </div>)}
        </div>
      </div>
    </section>;
}
function BonusesSection() {
  const bonuses = [{
    num: 1,
    title: 'GUÍA SOS 3 AM',
    desc: 'Tu salvavidas para el momento exacto en que nada funciona y el agotamiento te gana.',
    items: ['Guía rápida de crisis en PDF (para leer en 2 min)', 'Flujograma de Crisis en PDF', 'Protocolo de 5 pasos para usar en la oscuridad', 'Termómetro Emocional para saber cuándo podés seguir y cuándo pedir ayuda'],
    value: '4.500'
  }, {
    num: 2,
    title: 'GUÍA ALIMENTACIÓN Y SUEÑO',
    desc: 'Aprendé a distinguir si tu bebé se despierta por hambre real o por hábito, y cómo asegurar que llegue a la noche con el tanque lleno.',
    items: ['Tabla Hambre vs. Hábito', 'Protocolo de Tomas de Carga', 'El ciclo Come-Juega-Duerme', 'Los 5 mitos de alimentación y sueño que podés descartar para siempre'],
    value: '6.000'
  }, {
    num: 3,
    title: 'PACK DE PLANTILLAS "RUTINAS SIN CAOS"',
    desc: 'Horarios prediseñados por edad para no tener que calcular nada. Imprimí y usá desde hoy.',
    items: ['4 Rutinas completas (0 a 3 · 3 a 6 · 6 a 9 · 9 a 12 meses)', 'Tracker diario de 7 días', 'Versión para heladera (para papá · abuela · niñera)', 'Tabla de transición de siestas'],
    value: '3.500'
  }];
  return <section className="bg-cream py-20 px-6" data-id="element-103" data-mp="2y6ndq0jqzw5">
      <div className="max-w-5xl mx-auto" data-id="element-104" data-mp="2xddig6aju9s">
        <h2 className="font-playfair text-3xl md:text-4xl text-salvia-dark font-bold text-center mb-16 flex items-center justify-center" data-id="element-105" data-mp="gxfu7z2v4hng">
          <Gift className="w-10 h-10 mr-4 text-rose" data-id="element-106" data-mp="bzwh52hwiax3" />
          AL COMPRAR EL MANUAL RECIBÍS 3 BONOS EXCLUSIVOS DE REGALO
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-107" data-mp="2ir5equn48nte">
          {bonuses.map((bono, i) => <div key={i} className="bg-white rounded-2xl overflow-hidden shadow-md border border-gray-100 flex flex-col" data-id="element-108" data-mp="2dsav5qhbqv88" data-mpi={i}>
              <div className="bg-gold text-white p-6 text-center relative" data-id="element-109" data-mp="1wukh7mugdwv6">
                <Gift className="w-12 h-12 mx-auto mb-2 opacity-80" data-id="element-110" data-mp="21mc1jfn0n6cv" />
                <h3 className="font-playfair font-bold text-xl" data-id="element-111" data-mp="26low6mk4phq0">
                  BONO {bono.num}
                </h3>
                <p className="font-bold text-lg" data-id="element-112" data-mp="18yg9wpcb04my">{bono.title}</p>
              </div>
              <div className="p-6 flex-grow flex flex-col" data-id="element-113" data-mp="1dwrg8q3e3x0f">
                <p className="text-gray-600 mb-6 text-sm" data-id="element-114" data-mp="1dx9koa07hhjf">{bono.desc}</p>
                <ul className="space-y-3 mb-8 flex-grow" data-id="element-115" data-mp="1iv2tzbwt2rnx">
                  {bono.items.map((item, j) => <li key={j} className="flex items-start text-sm text-gray-700" data-id="element-116" data-mp="1nws3uo8akzaf" data-mpi={j}>
                      <Check className="w-4 h-4 text-salvia mr-2 flex-shrink-0 mt-0.5" data-id="element-117" data-mp="2za3zwcxt8dm1" />
                      <span data-id="element-118" data-mp="nn0sxyepn7a2">{item}</span>
                    </li>)}
                </ul>
                <div className="mt-auto pt-4 border-t border-gray-100 text-center" data-id="element-119" data-mp="inxks53fokxv">
                  <p className="text-gray-400 text-sm line-through mb-1" data-id="element-120" data-mp="iqa2ch5a4tae">
                    Valor real: ${bono.value} ARS
                  </p>
                  <p className="text-salvia font-bold text-lg flex items-center justify-center" data-id="element-121" data-mp="8x2zp41xbre0">
                    Con tu compra: GRATIS ✨
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}
function OffersSection() {
  return <section className="bg-cream py-20 px-6" id="ofertas" data-id="element-122" data-mp="3r4iph9p18rv6">
      <div className="max-w-5xl mx-auto" data-id="element-123" data-mp="3m4wbuz5al9lu">
        <h2 className="font-playfair text-3xl md:text-4xl text-salvia-dark font-bold text-center mb-16" data-id="element-124" data-mp="3m5xvhs0dj4f6">
          💎 ELEGÍ TU PACK
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-125" data-mp="1kd9pxc09c4w8">
          {/* Oferta 1 */}
          <div className="bg-white rounded-2xl p-8 border-2 border-rose flex flex-col shadow-sm" data-id="element-126" data-mp="2c72s4s45i55t">
            <div className="mb-6" data-id="element-127" data-mp="278j6ytxdsxei">
              <h3 className="font-playfair text-2xl font-bold text-gray-800 mb-2" data-id="element-128" data-mp="279kfaqn0j5sj">
                📖 OFERTA 1
              </h3>
              <p className="text-rose font-bold text-lg" data-id="element-129" data-mp="22fg6s2y3mppc">
                PACK: EL MANUAL DEL SUEÑO INFANTIL
              </p>
            </div>

            <ul className="space-y-4 mb-8 flex-grow" data-id="element-130" data-mp="1th4m0hjwym4t">
              <li className="flex items-start" data-id="element-131" data-mp="1terubcocsxek">
                <Check className="w-5 h-5 text-salvia mr-3 flex-shrink-0" data-id="element-132" data-mp="1ohi5nz8sgprs" />{' '}
                <span className="text-gray-700" data-id="element-133" data-mp="1jif5as3r77q5">
                  Manual completo (0-12 meses)
                </span>
              </li>
              <li className="flex items-start" data-id="element-134" data-mp="1ekvlzds784rc">
                <Check className="w-5 h-5 text-salvia mr-3 flex-shrink-0" data-id="element-135" data-mp="3dwpoajxo37o0" />{' '}
                <span className="text-gray-700" data-id="element-136" data-mp="3dully6ff2gpu">Bono 1: Guía SOS 3 AM</span>
              </li>
              <li className="flex items-start" data-id="element-137" data-mp="38vihan3cmcie">
                <Check className="w-5 h-5 text-salvia mr-3 flex-shrink-0" data-id="element-138" data-mp="3hff2vg92oeu3" />{' '}
                <span className="text-gray-700" data-id="element-139" data-mp="3lfz1ko9anqic">
                  Bono 2: Alimentación y Sueño
                </span>
              </li>
              <li className="flex items-start" data-id="element-140" data-mp="3q88kvlfwlsbn">
                <Check className="w-5 h-5 text-salvia mr-3 flex-shrink-0" data-id="element-141" data-mp="3v60o3bm010v5" />{' '}
                <span className="text-gray-700" data-id="element-142" data-mp="3v84ovkolpjr7">
                  Bono 3: Pack Plantillas Rutinas
                </span>
              </li>
            </ul>

            <div className="text-center mt-auto" data-id="element-143" data-mp="32ie9777bm9sz">
              <p className="text-gray-400 line-through mb-2" data-id="element-144" data-mp="32j656j4ty9js">
                Valor total: $39.000 ARS
              </p>
              <p className="text-sm font-bold text-gray-600 mb-1" data-id="element-145" data-mp="3cf94zic7lw3k">HOY SOLO:</p>
              <p className="text-4xl font-bold text-salvia mb-6" data-id="element-146" data-mp="3cd6b2n7xritk">$15.000 ARS</p>
              <a href="https://www.mamasincaos.store/cart/45253862490135:1" onClick={() => trackInitiateCheckout(15000, 'Pack: El manual del sueño infantil')} className="block w-full bg-salvia hover:bg-salvia-dark text-white font-bold py-4 px-6 rounded-xl transition-colors duration-300 text-center" data-id="element-147" data-mp="mpyrkw0903yo">
                QUIERO ESTE PACK
              </a>
            </div>
          </div>

          {/* Oferta 2 */}
          <div className="bg-white rounded-2xl p-8 border-4 border-gold flex flex-col shadow-xl relative transform md:-translate-y-4" data-id="element-148" data-mp="3fgu9faidwbtt">
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-gold text-white px-6 py-1 rounded-full font-bold text-sm shadow-md whitespace-nowrap" data-id="element-149" data-mp="3aev783ydrkyg">
              ⭐ MÁS ELEGIDO ⭐
            </div>

            <div className="mb-6 mt-2" data-id="element-150" data-mp="2wp1e39fueeix">
              <h3 className="font-playfair text-2xl font-bold text-gray-800 mb-2" data-id="element-151" data-mp="2wo04l9eh603b">
                📖📔 OFERTA 2
              </h3>
              <p className="text-gold font-bold text-lg" data-id="element-152" data-mp="2ronemfsb4cwi">
                PACK COMPLETO + BITÁCORA DE 21 DÍAS
              </p>
            </div>

            <ul className="space-y-4 mb-8 flex-grow" data-id="element-153" data-mp="1c07dznaokvsb">
              <li className="flex items-start" data-id="element-154" data-mp="xa9nh0pa3tzy">
                <Check className="w-5 h-5 text-salvia mr-3 flex-shrink-0" data-id="element-155" data-mp="xbkpauz5yrof" />{' '}
                <span className="text-gray-700" data-id="element-156" data-mp="128ky3dnee8j8">
                  Manual completo (0-12 meses)
                </span>
              </li>
              <li className="flex items-start" data-id="element-157" data-mp="1pzqatjy1kkpb">
                <Check className="w-5 h-5 text-salvia mr-3 flex-shrink-0" data-id="element-158" data-mp="1uyjrfl8mkrtp" />{' '}
                <span className="text-gray-700" data-id="element-159" data-mp="1gy8x2883wv3s">Bono 1: Guía SOS 3 AM</span>
              </li>
              <li className="flex items-start" data-id="element-160" data-mp="1h0lgkptijdiy">
                <Check className="w-5 h-5 text-salvia mr-3 flex-shrink-0" data-id="element-161" data-mp="1kysrh41apkm8" />{' '}
                <span className="text-gray-700" data-id="element-162" data-mp="5iu2fb3defbu">
                  Bono 2: Alimentación y Sueño
                </span>
              </li>
              <li className="flex items-start" data-id="element-163" data-mp="9m8g3v3u6jm4">
                <Check className="w-5 h-5 text-salvia mr-3 flex-shrink-0" data-id="element-164" data-mp="prjwpyayo3wb" />{' '}
                <span className="text-gray-700" data-id="element-165" data-mp="l13gk6fra469">
                  Bono 3: Pack Plantillas Rutinas
                </span>
              </li>
              <li className="flex items-start bg-gold-soft p-3 rounded-lg mt-4" data-id="element-166" data-mp="g31ynou2gawd">
                <BookOpen className="w-5 h-5 text-gold mr-3 flex-shrink-0 mt-1" data-id="element-167" data-mp="b3fjh9uogkkx" />
                <div className="text-gray-800" data-id="element-168" data-mp="18qo3f0f15lkt">
                  <span className="font-bold" data-id="element-169" data-mp="18pctsjywljls">
                    El Diario de la Madrugada (Bitácora de 21 días)
                  </span>
                  <p className="text-sm mt-1 text-gray-600 italic" data-id="element-170" data-mp="13pru27bwt780">
                    El complemento que convierte el manual en un plan de acción
                    día a día: registrás, ajustás y ves tu progreso paso a paso.
                  </p>
                  <ul className="text-sm mt-2 space-y-1 text-gray-600" data-id="element-171" data-mp="3jjih0ms2ssvj">
                    <li data-id="element-172" data-mp="3fgm3vblb1oyz">→ 21 Fichas de Registro Diario</li>
                    <li data-id="element-173" data-mp="3fj8drhvo4gkd">→ 3 Auditorías Semanales</li>
                    <li data-id="element-174" data-mp="1uzw7unjsofl4">→ Gráfico de Progreso</li>
                    <li data-id="element-175" data-mp="1ux9ycidcfq09">→ Momentos Mamá</li>
                  </ul>
                </div>
              </li>
            </ul>

            <div className="text-center mt-auto" data-id="element-176" data-mp="2401dot9cb5x6">
              <p className="text-gray-400 line-through mb-2" data-id="element-177" data-mp="23y86ncutejon">
                Valor total: $47.500 ARS
              </p>
              <p className="text-sm font-bold text-gray-600 mb-1" data-id="element-178" data-mp="28skqvp447z1g">HOY SOLO:</p>
              <p className="text-4xl font-bold text-salvia mb-2" data-id="element-179" data-mp="2dp2ps8crl35v">$18.900 ARS</p>
              <p className="text-xs text-gray-500 mb-6" data-id="element-180" data-mp="2inmc49v9sgyr">
                Solo $3.900 más que la Oferta 1 y te llevás la Bitácora que
                sostiene el método por 21 días.
              </p>
              <a href="https://www.mamasincaos.store/cart/45253875597335:1" onClick={() => trackInitiateCheckout(18900, 'Pack completo + Bitácora de 21 días')} className="block w-full bg-salvia hover:bg-salvia-dark text-white font-bold py-4 px-6 rounded-xl transition-colors duration-300 text-lg shadow-lg text-center" data-id="element-181" data-mp="2roaqx6shmlcp">
                QUIERO EL PACK COMPLETO
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}
function GuaranteeSection() {
  return <section className="bg-salvia-soft py-20 px-6" data-id="element-182" data-mp="2jl4euim7xxcd">
      <div className="max-w-3xl mx-auto text-center" data-id="element-183" data-mp="2jjt8cb1e2bhk">
        <ShieldCheck className="w-20 h-20 text-salvia mx-auto mb-8" data-id="element-184" data-mp="2em9kcjew2kcf" />
        <h2 className="font-playfair text-3xl md:text-4xl text-salvia-dark font-bold mb-8" data-id="element-185" data-mp="2ejx72jk2sy5p">
          GARANTÍA DE 7 DÍAS SIN PREGUNTAS Y SIN VUELTAS
        </h2>

        <div className="space-y-6 text-lg text-gray-700" data-id="element-186" data-mp="2ocvvo1fkoopb">
          <p data-id="element-187" data-mp="32bltjja7useq">
            Tenés 7 días de garantía para entrar al Manual, leerlo por dentro,
            aplicar las primeras técnicas y llegar a tu propia conclusión sobre
            si este material es para vos.
          </p>
          <p data-id="element-188" data-mp="3gy1agilr60pg">
            Si en ese período sentís que no es lo que necesitabas,{' '}
            <span className="font-bold text-salvia" data-id="element-189" data-mp="3lxxcwdesxk2w">
              te devolvemos el 100% de tu dinero
            </span>
            . Sin preguntas. Sin formularios largos. Sin vueltas.
          </p>
          <div className="w-16 h-px bg-salvia mx-auto my-8" data-id="element-190" data-mp="3byom1tf8glkr"></div>
          <p className="font-bold text-salvia-dark" data-id="element-191" data-mp="3c11384d62rwr">
            ¿Por qué ofrecemos esta garantía?
          </p>
          <p data-id="element-192" data-mp="32yjglotlnx98">
            Porque confiamos en lo que creamos. Porque sabemos que cuando una
            mamá agotada aplica este método, los resultados hablan solos. Y
            porque creemos que tu confianza vale más que cualquier venta.
          </p>
        </div>

        <div className="mt-12 flex flex-col md:flex-row justify-center items-center gap-6 text-rose font-medium" data-id="element-193" data-mp="2t8zzoopg6dh0">
          <span className="flex items-center" data-id="element-194" data-mp="2fbbcvbbtkw9b">
            <MailIcon className="w-5 h-5 mr-2" data-id="element-195" data-mp="2j9hde1m2efls" /> soporte.mamasinkos@gmail.com
          </span>
          <span className="hidden md:inline text-gray-300" data-id="element-196" data-mp="2zqbcxamoyax2">|</span>
          <a href="https://www.instagram.com/mamasiincaos/" target="_blank" rel="noopener noreferrer" className="flex items-center hover:text-salvia transition-colors" data-id="element-197" data-mp="2uqys0vfdrdx4">
            <InstagramIcon className="w-5 h-5 mr-2" data-id="element-198" data-mp="2ktkd5093ux6x" /> @mamasiincaos
          </a>
        </div>
      </div>
    </section>;
}
function ValueSummarySection() {
  return <section className="bg-cream py-20 px-6" data-id="element-199" data-mp="2c0h6basytil9">
      <div className="max-w-3xl mx-auto" data-id="element-200" data-mp="2bzp7zs7zh6ra">
        <h2 className="font-playfair text-3xl text-salvia-dark font-bold text-center mb-10" data-id="element-201" data-mp="2bymgpj6r12au">
          💰 MIRÁ TODO LO QUE TE LLEVÁS
        </h2>

        <div className="bg-white rounded-2xl p-8 shadow-md border border-gray-100" data-id="element-202" data-mp="223ceaucfuswj">
          <div className="space-y-4 mb-8" data-id="element-203" data-mp="1x3gb2xbkf5i1">
            <div className="flex justify-between items-center text-gray-600" data-id="element-204" data-mp="1x2ewiivcc0vk">
              <span className="flex items-center" data-id="element-205" data-mp="1t2wdjsn2xzvd">
                <BookOpen className="w-5 h-5 mr-3 text-salvia" data-id="element-206" data-mp="8jkhdq10dd9b" /> Pack: El
                manual del sueño infantil
              </span>
              <span data-id="element-207" data-mp="ck4it5sm7319">$25.000</span>
            </div>
            <div className="flex justify-between items-center text-gray-600" data-id="element-208" data-mp="cn0bofplv1iu">
              <span className="flex items-center" data-id="element-209" data-mp="hl207g5svt1p">
                <Gift className="w-5 h-5 mr-3 text-rose" data-id="element-210" data-mp="mjlkzd8nqysh" /> Bono 1: SOS 3 AM
              </span>
              <span data-id="element-211" data-mp="3l1hbaz1kk3ea">$4.500</span>
            </div>
            <div className="flex justify-between items-center text-gray-600" data-id="element-212" data-mp="3l2seawn6x74c">
              <span className="flex items-center" data-id="element-213" data-mp="3q0txdhkm96ft">
                <Gift className="w-5 h-5 mr-3 text-rose" data-id="element-214" data-mp="3uzf29uatceal" /> Bono 2: Alimentación
              </span>
              <span data-id="element-215" data-mp="3k7n4k7t53wp">$6.000</span>
            </div>
            <div className="flex justify-between items-center text-gray-600" data-id="element-216" data-mp="3m26vv7cepz7">
              <span className="flex items-center" data-id="element-217" data-mp="329g8xmpl5v04">
                <Gift className="w-5 h-5 mr-3 text-rose" data-id="element-218" data-mp="328n6gxxntrns" /> Bono 3: Plantillas
              </span>
              <span data-id="element-219" data-mp="3777ywb6o771o">$3.500</span>
            </div>
            <div className="flex justify-between items-center text-gray-600" data-id="element-220" data-mp="2h0ovcxqzskuv">
              <span className="flex items-center" data-id="element-221" data-mp="2lz9uetuicyhq">
                <BookOpen className="w-5 h-5 mr-3 text-gold" data-id="element-222" data-mp="2lwnoszr6gt25" /> Bitácora 21 Días
                (solo en Oferta 2)
              </span>
              <span data-id="element-223" data-mp="2c0akz91x4yto">$8.500</span>
            </div>
          </div>

          <div className="border-t border-gray-200 pt-6 mb-6" data-id="element-224" data-mp="2c2ncactkglje">
            <div className="flex justify-between items-center mb-4" data-id="element-225" data-mp="1y84debcu005u">
              <span className="font-bold text-gray-500" data-id="element-226" data-mp="22zm8wjw358jf">VALOR TOTAL:</span>
              <span className="text-red-400 line-through text-xl" data-id="element-227" data-mp="231p7hsbb09zr">
                $47.500 ARS
              </span>
            </div>
            <div className="flex justify-between items-center mb-2" data-id="element-228" data-mp="1t9jbm7hxl8fa">
              <span className="font-bold text-gray-800" data-id="element-229" data-mp="1fabctfpok2bm">OFERTA 1:</span>
              <span className="font-bold text-salvia text-2xl" data-id="element-230" data-mp="1fb38eqja201w">
                $15.000 ARS
              </span>
            </div>
            <div className="flex justify-between items-center" data-id="element-231" data-mp="10nl2xpxw51ef">
              <span className="font-bold text-gray-800" data-id="element-232" data-mp="10nusxdixr8k4">OFERTA 2:</span>
              <span className="font-bold text-salvia text-2xl" data-id="element-233" data-mp="vpjk964dn43h">
                $18.900 ARS
              </span>
            </div>
          </div>

          <div className="bg-gold-soft p-4 rounded-lg flex items-start mb-8" data-id="element-234" data-mp="19ly2dbgncevk">
            <span className="text-xl mr-3" data-id="element-235" data-mp="15le60a3wdfah">⚠️</span>
            <p className="text-sm text-gray-800" data-id="element-236" data-mp="1jlxaj795m37w">
              <span className="font-bold" data-id="element-237" data-mp="1jkma9hex3dlj">SOLO DISPONIBLE EN ESTA PÁGINA.</span>{' '}
              Si salís, esta oferta no estará disponible al mismo precio.
            </p>
          </div>

          <a href="https://www.mamasincaos.store/cart/45253875597335:1" onClick={() => trackInitiateCheckout(18900, 'Pack completo + Bitácora de 21 días')} className="w-full bg-rose hover:bg-rose-600 text-white font-bold py-5 px-6 rounded-xl transition-colors duration-300 text-lg shadow-lg flex justify-center items-center" data-id="element-238" data-mp="1tbqp8h4leygd">
            ✨ SÍ, QUIERO MIS NOCHES DE VUELTA ✨
          </a>
        </div>
      </div>
    </section>;
}
function FAQSection() {
  const faqs = [{
    q: '¿Es un método de llanto controlado o de dejar llorar?',
    a: 'No, para nada. El Manual está pensado desde el amor, el respeto y la presencia constante. Vas a enseñarle a tu bebé a dormir de forma gradual, sin abandonarlo a su llanto en ningún momento.'
  }, {
    q: '¿Funciona con bebés que toman teta?',
    a: 'Sí. El método respeta la lactancia y te muestra cómo distinguir el hambre real del hábito, y cómo ir soltando de a poco la asociación teta-sueño sin destetar ni forzar nada.'
  }, {
    q: '¿Desde qué edad puedo aplicarlo?',
    a: 'El manual cubre desde recién nacidos hasta bebés de 12 meses, con tablas y protocolos específicos para cada etapa. Incluso podés empezar durante el embarazo para llegar preparada.'
  }, {
    q: '¿Cuánto tiempo tarda en verse resultados?',
    a: 'La mayoría de las mamás reportan cambios notables entre el día 5 y el día 14 de aplicación consistente del método.'
  }, {
    q: '¿Por cuánto tiempo voy a tener acceso al manual?',
    a: 'Acceso de por vida al eBook y a todos los bonos descargables. Una vez que lo descargás, es tuyo para siempre.'
  }, {
    q: '¿Cómo recibo el acceso?',
    a: 'Inmediatamente después de tu compra recibís un mail con el link de descarga directa de todos los archivos PDF. Sin esperas. Sin contraseñas.'
  }, {
    q: '¿La plataforma de pago es segura?',
    a: 'Sí. Procesamos los pagos a través de plataformas certificadas con encriptación SSL. Tus datos están 100% protegidos.'
  }, {
    q: '¿Tengo dudas antes de comprar, con quién hablo?',
    a: 'Escribinos por Instagram @mamasiincaos o al mail soporte.mamasinkos@gmail.com. Te respondemos en menos de 24 horas.'
  }];
  return <section className="bg-offwhite py-20 px-6" data-id="element-239" data-mp="79jo5q7zmf0j">
      <div className="max-w-3xl mx-auto" data-id="element-240" data-mp="77p56hga0wz3">
        <h2 className="font-playfair text-3xl md:text-4xl text-salvia-dark font-bold text-center mb-12" data-id="element-241" data-mp="c0s0ov4m6ghx">
          ❓ PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-4" data-id="element-242" data-mp="3ucersnt3tbe4">
          {faqs.map((faq, i) => <FAQItem key={i} question={faq.q} answer={faq.a} data-id="element-243" data-mp="2bi535akafp2" data-mpi={i} />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-gray-200 rounded-xl overflow-hidden bg-white shadow-sm" data-id="element-244" data-mp="gzv5qfklgmpw">
      <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={() => setIsOpen(!isOpen)} data-id="element-245" data-mp="lyo8pe298vbt">
        <span className="font-bold text-salvia" data-id="element-246" data-mp="31oiv3j3jbjhc">{question}</span>
        {isOpen ? <Minus className="w-5 h-5 text-rose flex-shrink-0" data-id="element-247" data-mp="36qi0szmqyshg" /> : <Plus className="w-5 h-5 text-rose flex-shrink-0" data-id="element-248" data-mp="2y74vzjuxt8i7" />}
      </button>
      <AnimatePresence data-id="element-249" data-mp="2u6ujdocn3jud">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} className="overflow-hidden bg-cream" data-id="element-250" data-mp="2u61ktanu40nb">
            <div className="px-6 py-5 text-gray-700 border-t border-gray-100" data-id="element-251" data-mp="2aiu0yxbxa31u">
              → {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
function FinalCTASection() {
  return <section className="bg-salvia-dark text-white py-24 px-6 relative overflow-hidden flex flex-col items-center text-center" data-id="element-252" data-mp="2kex4o7mfa9qw">
      <div className="max-w-3xl mx-auto z-10" data-id="element-253" data-mp="1woui271a1vzo">
        <Moon className="w-12 h-12 text-rose mx-auto mb-8" data-id="element-254" data-mp="1rsm2isj640rz" />

        <h2 className="font-playfair text-4xl md:text-[48px] leading-tight mb-8" data-id="element-255" data-mp="3ru3k1e7sylov">
          ¿Hace cuánto que no dormís más de 3 horas seguidas?
        </h2>

        <div className="text-rose text-lg md:text-xl space-y-6 mb-12" data-id="element-256" data-mp="m7ua935sw7l">
          <p data-id="element-257" data-mp="5e913fhk5uq8">
            Tu bebé puede aprender a dormir. No porque lo abandones a su llanto.
            Sino porque vos le vas a enseñar, con amor, con método y con
            paciencia.
          </p>
          <p data-id="element-258" data-mp="38vzjh85zduyo">Y nosotras vamos a acompañarte en cada paso del proceso.</p>
        </div>

        <p className="font-playfair italic text-2xl mb-12" data-id="element-259" data-mp="3dtss07urb124">
          Las noches tranquilas que merecés están a un clic de distancia.
        </p>

        <a href="https://www.mamasincaos.store/cart/45253875597335:1" onClick={() => trackInitiateCheckout(18900, 'Pack completo + Bitácora de 21 días')} className="inline-block w-full md:w-auto bg-rose hover:bg-rose-600 text-white font-bold py-5 px-10 rounded-xl transition-colors duration-300 text-xl shadow-lg mb-16 text-center" data-id="element-260" data-mp="3hul2t5ja1e0i">
          ✨ QUIERO MIS NOCHES DE VUELTA ✨
        </a>

        <div className="flex flex-col items-center space-y-6 border-t border-salvia pt-12" data-id="element-261" data-mp="1793rbv3ue60y">
          <span className="font-playfair text-2xl font-bold tracking-wider text-white" data-id="element-262" data-mp="12idkedfrpv45">
            Mamá sin Caos
          </span>
          <div className="flex flex-col md:flex-row gap-4 md:gap-8 text-sm text-salvia-light" data-id="element-263" data-mp="ygijvb5nvlrf">
            <a href="https://www.instagram.com/mamasiincaos/" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center hover:text-white transition-colors" data-id="element-264" data-mp="tj8pdh3f0jwq">
              <InstagramIcon className="w-4 h-4 mr-2" data-id="element-265" data-mp="fifrcmdwn6ov" /> @mamasiincaos
            </a>
            <span className="flex items-center justify-center" data-id="element-266" data-mp="fksgpklzsjby">
              <MailIcon className="w-4 h-4 mr-2" data-id="element-267" data-mp="2dwr73eysc4il" /> soporte.mamasinkos@gmail.com
            </span>
            <a href="https://www.mamasincaos.store/" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center hover:text-white transition-colors" data-id="element-268" data-mp="29xs25ud207r5">
              <GlobeIcon className="w-4 h-4 mr-2" data-id="element-269" data-mp="2jff6b1k9ldx1" /> mamasincaos.store
            </a>
          </div>
          <p className="text-xs text-salvia-light mt-8" data-id="element-270" data-mp="2oeia6ioide3f">
            © 2024 Mamá sin Caos Todos los derechos reservados.
          </p>
        </div>
      </div>
    </section>;
}
// Simple Icon wrappers for lucide-react missing ones or specific uses
function MailIcon(props: any) {
  return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props} data-id="element-271" data-mp="2edy85dt605k5">
      <rect width="20" height="16" x="2" y="4" rx="2" data-id="element-272" data-mp="3uvvm4vzqdwkf" />
      <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" data-id="element-273" data-mp="3nzm8y1diqpf" />
    </svg>;
}
function InstagramIcon(props: any) {
  return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props} data-id="element-274" data-mp="drenjcymp36r">
      <rect width="20" height="20" x="2" y="2" rx="5" ry="5" data-id="element-275" data-mp="htt944tomh1q" />
      <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" data-id="element-276" data-mp="hs8fqij3t45g" />
      <line x1="17.5" x2="17.51" y1="6.5" y2="6.5" data-id="element-277" data-mp="whwgnindi0sn" />
    </svg>;
}
function GlobeIcon(props: any) {
  return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props} data-id="element-278" data-mp="rijjo52sfdcc">
      <circle cx="12" cy="12" r="10" data-id="element-279" data-mp="37aqxrezmnq84" />
      <line x1="2" x2="22" y1="12" y2="12" data-id="element-280" data-mp="37bs6hct680mo" />
      <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" data-id="element-281" data-mp="37ck5kxlz8ghp" />
    </svg>;
}